import { render, staticRenderFns } from "./how-to.vue?vue&type=template&id=6a2ce202&scoped=true&"
import script from "./how-to.vue?vue&type=script&lang=js&"
export * from "./how-to.vue?vue&type=script&lang=js&"
import style0 from "./how-to.vue?vue&type=style&index=0&id=6a2ce202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ce202",
  null
  
)

export default component.exports